import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ValidatedResult } from '../../Models/Models/ValidatedResult';
import { OneOffIncomePayment } from '../../Models/Models/Processes/Apply/Pension/OneOffIncomePayment';
import { PensionContributionModel } from '../../Models/Models/Processes/Apply/Pension/PensionContributionModel';

declare var IS_RUNNING_IN_APP_POOL;

export class OneOffIncomePaymentClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(subAccountHierarchyId: string, headAccountHierarchyId: string): Promise<ValidatedResult<string>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/OneOffIncomePayment/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId, headAccountHierarchyId: headAccountHierarchyId }

    return AjaxWrapper.post<ValidatedResult<string>, any>(url, data);
  }
  public get(hierarchyId: string, customerId: number, subAccountHierarchyId: string): Promise<OneOffIncomePayment, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/OneOffIncomePayment/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, customerId: customerId, subAccountHierarchyId: subAccountHierarchyId }

    return AjaxWrapper.get<OneOffIncomePayment, any>(url, data);
  }
  public put(model: PensionContributionModel, hierarchyId: string, customerId: number, subAccountHierarchyId: string): Promise<OneOffIncomePayment, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/OneOffIncomePayment/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { model: model, hierarchyId: hierarchyId, customerId: customerId, subAccountHierarchyId: subAccountHierarchyId }

    return AjaxWrapper.put<OneOffIncomePayment, any>(url, data);
  }
}

